export const MAX_APPLIED_SEGMENTS = 20;

export type AppliedSegmentsAction =
  | { type: 'toggle'; code: string }
  | { type: 'clearAll' }
  | { type: 'syncFromCommitted'; codes: string[] };

export function appliedSegmentsReducer(
  state: Set<string>,
  action: AppliedSegmentsAction,
): Set<string> {
  switch (action.type) {
    case 'toggle': {
      const next = new Set(state);
      if (next.has(action.code)) {
        next.delete(action.code);
      } else {
        if (next.size >= MAX_APPLIED_SEGMENTS) return state;
        next.add(action.code);
      }
      return next;
    }
    case 'clearAll':
      return new Set();
    case 'syncFromCommitted':
      return new Set(action.codes);
  }
}
